<template>
  <vue-scroll class="view box grow flex grid-2">
    <div class="box grow login-container">
      <div class="grid-logo">
        <div class="logo-box align-vertical">
          <div class="logo-container align-vertical-middle">
            <div>
              <img class="logo-letter" src="/static/images/horizontal_logo_white.svg" alt="logo" />
              <div class="logo-desc">Autonomous Detection and Response</div>
            </div>
          </div>
        </div>
      </div>
      <el-form
        class="flex align-center grid-content login-page align-vertical"
        :model="userForm"
        :rules="userRules"
        ref="passResetRef"
      >
        <div class="box form-wrapper align-vertical-middle">
          <div class="form-box">
            <div class="small-font h3" v-if="!passwordTokenResetStatus">
              <h3>Reset Your Password</h3>

              <el-form-item class="styled" label="Password" prop="password">
                <el-input type="password" v-model="userForm.password" autocomplete="off"></el-input>
                <el-progress
                  class="password-strength-meter"
                  :percentage="userForm.passwordStrengthScore"
                  :color="userForm.passwordStrengthColor"
                  :show-text="false"
                ></el-progress>
              </el-form-item>

              <el-form-item class="styled" label="Confirm Password" prop="confirmPassword">
                <el-input
                  type="password"
                  v-model="userForm.confirmPassword"
                  autocomplete="off"
                  v-on:keyup.enter="resetPassword()"
                ></el-input>
              </el-form-item>

              <div v-if="passwordTokenResetMessage" class="error message">
                <label>{{passwordTokenResetMessage}}</label>
              </div>

              <div class="flex text-center center mt-8 mb-8">
                <el-button
                  plain
                  size="small"
                  @click="resetPassword"
                  class="box grow login-btn"
                >Reset Password</el-button>
              </div>
            </div>
            <div v-else>
              <div class="styled message">
                <label>{{passwordTokenResetMessage}}</label>
              </div>

              <div class="flex text-center center mt-8 mb-8">
                <el-button
                  plain
                  size="small"
                  @click="login"
                  class="box grow login-btn"
                >Proceed to Login</el-button>
              </div>
            </div>
          </div>
        </div>
      </el-form>
    </div>
  </vue-scroll>
</template>

<script>
import { mapGetters } from "vuex";
import {
  AUTH_RESET_REQUEST,
  AUTH_RESET_REQUEST_CLEAR
} from "@/store/modules/auth/auth.type";
import { PasswordScoreColorEnum } from "@/constants/password-score.constants";
import { getPasswordStrengthColor } from "@/utilities/passwordstrength.helper";
import { validatePassword } from "@/utilities/user/validation";

export default {
  name: "PasswordResetToken",
  data() {
    return {
      userForm: {
        password: "",
        confirmPassword: "",
        passwordStrengthScore: 0,
        passwordStrengthColor: PasswordScoreColorEnum[0]
      },
      userRules: {
        password: [
          {
            required: true,
            min: 8,
            max: 64,
            trigger: "change",
            validator: (rule, value, callback) => {
              let validPassword = validatePassword(value);
              let passwordStrengthMeta = getPasswordStrengthColor(
                validPassword.score
              );
              this.userForm.passwordStrengthScore =
                passwordStrengthMeta.percentage;
              this.userForm.passwordStrengthColor = passwordStrengthMeta.color;
              if (validPassword.score > 2) {
                if (this.userForm.confirmPassword !== "") {
                  this.$refs["passResetRef"].validateField("confirmPassword");
                }
                callback();
              } else {
                callback(validPassword.error);
              }
            }
          }
        ],
        confirmPassword: [
          {
            required: true,
            trigger: "blur",
            validator: (rule, value, callback) => {
              if (value === "") {
                callback(new Error("Please input the password again"));
              } else if (value !== this.userForm.password) {
                callback(new Error("Passwords did not match!"));
              } else {
                callback();
              }
            }
          }
        ]
      },
      error: false
    };
  },
  created() {
    this.token = this.$route.params.token;
  },
  methods: {
    login() {
      this.$store.dispatch(AUTH_RESET_REQUEST_CLEAR);
      this.$router.push({ name: "login" });
    },
    resetPassword() {
      this.$refs["passResetRef"].validate(valid => {
        if (valid) {
          this.$store
            .dispatch(AUTH_RESET_REQUEST, {
              password: this.userForm.password,
              token: this.token
            })
            .then(
              () => {
                // this.$router.push({ name: "login" });
              },
              errMsg => {
                console.log(errMsg);
              }
            );
        }
      });
    }
  },
  computed: {
    ...mapGetters(["passwordTokenResetStatus", "passwordTokenResetMessage"])
  }
};
</script>

<style scoped>
@import "assets/styles/_variables.css";
@import "assets/styles/global_classes.css";
@import "assets/styles/text.css";
@import "assets/styles/login.css";

.layout-container .container .view {
  padding: 0px;
  padding-bottom: 0px;
}

.error {
  text-align: center;
  color: var(--text-color-danger);
}

.company-desc {
  font-size: 0.8em;
  color: black;
  margin-top: 24px;
}

.desc {
  font-size: 0.8em;
  color: black;
  margin-top: 68px;
}

>>> .el-loading-mask {
  background-color: white;
}

.logo-container {
  margin-right: 80px; /* account for text bleed over passed svg */

  > div {
    height: 235px; /* Match height of right grid content */
  }
}

.password-strength-meter {
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/login/PasswordResetToken.vue